import React, { PropTypes } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import updateUserRating from 'action/updateUserRating';
import _ from 'lodash';
import cx from 'classnames';

// Component to show and select user rating using stars

const STARS_NUMBER = 5;

const mapStateToProps = state => ({
  userRating: state.userRating,
});

export class StarsComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      suggestedRating: 0,
    };
  }

  setSuggestedRating(value) {
    this.setState({ suggestedRating: value });
  }

  onClick(value) {
    this.props.dispatch(updateUserRating(value));
    if (this.props.onSelect) {
      this.props.onSelect();
    }
  }

  render() {
    const rating = this.state.suggestedRating || this.props.userRating;
    return (
      <div className="stars" onMouseOut={() => this.setSuggestedRating(0)} >
        {_()
          .range(STARS_NUMBER)
          .map(i => (
            <div
              key={i}
              className={cx('stars__star', {'selected': rating && i < rating})}
              onClick={() => this.onClick(i + 1)}
              onMouseMove={() => this.setSuggestedRating(i + 1)}
            />
          ))
          .value()}
      </div>
    );
  }
}

StarsComponent.propTypes = {
  userRating: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
};

export default compose(
  connect(mapStateToProps)
)(StarsComponent);



// WEBPACK FOOTER //
// ./src/component/Feedback/Stars.jsx